import { RepositionModes } from "../../util/positioning.js";
// Re-export collision edge types for backwards compatibility
export { CollisionEdges } from "../../util/positioning.js";
export const PositioningShorthands = {
    aboveEnd: "above-end",
    aboveCenter: "above-center",
    aboveStart: "above-start",
    endBottom: "end-bottom",
    endMiddle: "end-middle",
    endTop: "end-top",
    belowEnd: "below-end",
    belowCenter: "below-center",
    belowStart: "below-start",
    startBottom: "start-bottom",
    startTop: "start-top",
    startMiddle: "start-middle"
};
// Preserve the established public runtime API while keeping the plural const
// as the canonical source for the shorthand values.
export const PositioningShorthand = PositioningShorthands;
export const PopoverPositions = Object.values(PositioningShorthands);
export const PopoverRepositionModes = {
    auto: RepositionModes.auto,
    flip: RepositionModes.flip,
    none: RepositionModes.none
};
export const PopoverEventNames = {
    hide: "hide-popover",
    show: "show-popover",
    toggle: "toggle-popover",
    mouseEnter: "mouse-enter-popover",
    mouseLeave: "mouse-leave-popover"
};
//# sourceMappingURL=popover.options.js.map